export const SIGNUP_INITIATED = 'SIGNUP_INITIATED';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAILED = 'SIGNUP_FAILED';
